import { For } from "solid-js";
import { runtimeConfig } from "../config";
import type { SteamAuthReturn } from "../core/session";
import { verifySteamCharacterSelection } from "../core/session";

type CharacterSelectionViewProps = {
  authReturn: SteamAuthReturn;
  onAuthenticated: () => void;
};

export function CharacterSelectionView(props: CharacterSelectionViewProps) {
  const selectCharacter = async (characterId: string | number) => {
    try {
      await verifySteamCharacterSelection(props.authReturn, characterId);
      props.onAuthenticated();
    } catch (reason) {
      console.error("Auth verify error", reason);
    }
  };

  return (
    <main class="dump-root flex h-screen w-full items-center justify-center px-14">
      <section class="flex flex-col items-center justify-center">
        <div class="flex flex-col items-center py-12">
          <img
            class="h-24 w-24 object-contain"
            style="filter:drop-shadow(2rem 0rem 4rem #08f8bb) drop-shadow(-2rem 0px 4rem #6c63e0)"
            src={`${runtimeConfig.assetOrigin}/logo.png`}
            alt=""
          />
          <p class="roboto700 text-center text-4xl text-white">nopixel</p>
          <p class="roboto400 mb-4 text-center text-xl text-white">
            User Selecting
          </p>
          <p class="roboto400 w-1/3 text-center text-lg text-gray-400">
            MDT User Selection refers to the critical process employed by law
            enforcement officers to identify and access specific user profiles
            or records within the Mobile Data Terminal system. This capability
            is vital for efficient information retrieval and management during
            police operations and investigations.
          </p>
        </div>

        <ul class="flex gap-2">
          <For each={props.authReturn.characters}>
            {(character) => (
              <li
                class="group cursor-pointer"
                onClick={() => void selectCharacter(character.id)}
              >
                <div style="background:radial-gradient(141.63% 67.03% at 50% 50%, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 100%)">
                  <div class="border-box z-1 h-32 w-32 bg-nopixel-dark p-1 group-hover:bg-nopixel-light">
                    <img
                      class="h-full w-full"
                      src={character.profilePicture}
                      alt=""
                    />
                  </div>
                  <p class="roboto700 text-lg text-white">{character.name}</p>
                  <p class="roboto400 bg-nopixel-dark px-2 text-center text-lg text-gray-100 group-hover:bg-nopixel-light">
                    {character.id}
                  </p>
                </div>
              </li>
            )}
          </For>
        </ul>

      </section>
    </main>
  );
}
